import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "others-settings"
};
const _hoisted_2 = {
  class: "first-settings"
};
const _hoisted_3 = {
  class: "first-title"
};
const _hoisted_4 = {
  class: "first-title"
};
const _hoisted_5 = {
  class: "first-title"
};
const _hoisted_6 = {
  class: "first-title"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "first-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_FloatingSaveButton = _resolveComponent("FloatingSaveButton");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('sysOthers.remoteTelemetry')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysOthers.remoteTelemetryTooltip'),
    placement: "right"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.settings.telemetry,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.enable')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.settings.telemetry.enabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.settings.telemetry.enabled = $event),
        disabled: $data.settings.telemetry.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h3", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t('sysOthers.cloudflareApiToken')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysOthers.cloudflareApiTokenTooltip'),
    placement: "right",
    "raw-content": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.settings.cloudflareApiToken,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.zoneId')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.cloudflareApiToken.CF_ZONE_ID,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.settings.cloudflareApiToken.CF_ZONE_ID = $event),
        disabled: $data.settings.cloudflareApiToken.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.accountEmail')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.cloudflareApiToken.CF_EMAIL,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.settings.cloudflareApiToken.CF_EMAIL = $event),
        disabled: $data.settings.cloudflareApiToken.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: "API Key"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.cloudflareApiToken.CF_API_KEY,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.settings.cloudflareApiToken.CF_API_KEY = $event),
        disabled: $data.settings.cloudflareApiToken.fixed,
        type: "password",
        "show-password": "",
        autocomplete: "new-password"
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h3", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$t('sysOthers.randomImageApi')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysOthers.randomImageApiTooltip'),
    placement: "right"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.settings.randomImageAPI,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.enable')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.settings.randomImageAPI.enabled,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.settings.randomImageAPI.enabled = $event),
        disabled: $data.settings.randomImageAPI.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      prop: "randomImageAPI.allowedDir"
    }, {
      label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('sysOthers.directory')), 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysOthers.directoryTooltip'),
        placement: "right",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.randomImageAPI.allowedDir,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.settings.randomImageAPI.allowedDir = $event),
        disabled: $data.settings.randomImageAPI.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h3", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t('sysOthers.publicBrowse')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysOthers.publicBrowseTooltip'),
    placement: "right",
    "raw-content": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.settings.publicBrowse,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.enable')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.settings.publicBrowse.enabled,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.settings.publicBrowse.enabled = $event),
        disabled: $data.settings.publicBrowse.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      prop: "publicBrowse.allowedDir"
    }, {
      label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('sysOthers.openDirectory')), 1), _createVNode(_component_el_tooltip, {
        placement: "right",
        "raw-content": ""
      }, {
        content: _withCtx(() => [_createElementVNode("div", {
          style: {
            "max-width": "320px",
            "line-height": "1.6"
          },
          innerHTML: _ctx.$t('sysOthers.openDirectoryTooltip')
        }, null, 8, _hoisted_7)]),
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      })]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.publicBrowse.allowedDir,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.settings.publicBrowse.allowedDir = $event),
        disabled: $data.settings.publicBrowse.fixed,
        placeholder: "wallpaper,photos,album"
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h3", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t('sysOthers.webdav')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysOthers.webdavTooltip'),
    placement: "right",
    "raw-content": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.settings.webDAV,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.enable')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.settings.webDAV.enabled,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.settings.webDAV.enabled = $event),
        disabled: $data.settings.webDAV.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.webdavUsername')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.webDAV.username,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.settings.webDAV.username = $event),
        disabled: $data.settings.webDAV.fixed
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.webdavPassword')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.settings.webDAV.password,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.settings.webDAV.password = $event),
        disabled: $data.settings.webDAV.fixed,
        type: "password",
        "show-password": "",
        autocomplete: "new-password"
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysOthers.webdavUploadChannel')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.settings.webDAV.uploadChannel,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.settings.webDAV.uploadChannel = $event),
        disabled: $data.settings.webDAV.fixed,
        placeholder: _ctx.$t('sysOthers.webdavDefaultChannel'),
        clearable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "Telegram",
          value: "telegram"
        }), _createVNode(_component_el_option, {
          label: "Cloudflare R2",
          value: "cfr2"
        }), _createVNode(_component_el_option, {
          label: "S3",
          value: "s3"
        }), _createVNode(_component_el_option, {
          label: "Discord",
          value: "discord"
        }), _createVNode(_component_el_option, {
          label: "HuggingFace",
          value: "huggingface"
        }), _createVNode(_component_el_option, {
          label: "WebDAV",
          value: "webdav"
        })]),
        _: 1
      }, 8, ["modelValue", "disabled", "placeholder"])]),
      _: 1
    }, 8, ["label"]), $data.settings.webDAV.uploadChannel && $options.webdavChannelList.length > 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: _ctx.$t('sysOthers.webdavChannelName')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.settings.webDAV.channelName,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.settings.webDAV.channelName = $event),
        disabled: $data.settings.webDAV.fixed,
        placeholder: _ctx.$t('uploadSettings.autoSelect'),
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.webdavChannelList, ch => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: ch.name,
            label: ch.name,
            value: ch.name
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "disabled", "placeholder"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model"])]), _createVNode(_component_FloatingSaveButton, {
    show: !$data.loading,
    onClick: $options.saveSettings
  }, null, 8, ["show", "onClick"])])), [[_directive_loading, $data.loading]]);
}